var _circle, _circle2, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconTalentlenz(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    role: "img",
    "aria-label": "TalentLenz",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 12,
    cy: 10,
    r: 5,
    fill: "none",
    stroke: "#FF2775",
    strokeWidth: 2
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 23,
    cy: 12,
    r: 4,
    fill: "none",
    stroke: "#FF2775",
    strokeWidth: 2
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M3.5 27c.8-7 4.2-10 8.5-10s7.7 3 8.5 10M19 19c4.5-.7 8.4 1.4 9.5 7",
    fill: "none",
    stroke: "#FF2775",
    strokeWidth: 2,
    strokeLinecap: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconTalentlenz);
export default __webpack_public_path__ + "static/media/icon-talentlenz.32f7084b0f0b90b70729e5872655035f.svg";
export { ForwardRef as ReactComponent };